import { render } from "./EmailConfirmationInProgress.vue?vue&type=template&id=687e70c4"
import script from "./EmailConfirmationInProgress.vue?vue&type=script&lang=js"
export * from "./EmailConfirmationInProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__